import React from 'react';
import Divider from "@material-ui/core/Divider/Divider";

export const MDivider = ({style}) => <Divider style={style}/>
